<template>
    <div>
        <h1 style="font-size: 24px; color: black;">AbTest</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="应用名称：">
                    <el-select v-model="queryData.appName" placeholder="请选择" clearable>
                        <el-option
                            v-for="app in appList"
                            :key="app.appId"
                            :label="app.appName"
                            :value="app.packageName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11">
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button class="sub-sub" type="primary" @click="showAddConstantConfigFormDialog('添加配置')">
                        添加配置
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号ID" align="center"></el-table-column>
                <el-table-column prop="name" label="策略组名" align="center"></el-table-column>
                <el-table-column prop="type" label="策略类型" align="center"
                                 :formatter="typeFormatter"></el-table-column>
                <el-table-column prop="appName" label="包名" align="center"></el-table-column>
                <el-table-column prop="configValue" label="策略值" align="center"></el-table-column>
                <el-table-column prop="relName" label="关联常量名" align="center"></el-table-column>
                <el-table-column prop="userStartDate" label="用户开始时间" align="center"
                                 :formatter="formatSimpleDate"></el-table-column>
                <el-table-column label="是否可用" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.enable ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="关联渠道" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.subChannelName.length === 0 ? " " : scope.row.subChannelName.join(" , ") }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDt" label="创建时间" :formatter="formatDate"></el-table-column>
                <el-table-column prop="updateDt" label="更新时间" :formatter="formatDate"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showAddConstantConfigFormDialog('编辑配置',scope.row)">编辑
                        </el-button>
                        <el-button type="text" @click="removeConstantConfig(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogConstantConfigTitle" center :visible.sync="dialogConstantConfigVisible" width="800px">
            <el-form :model="addConstantConfigForm">
                <el-form-item label="策略组名 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.name "></el-input>
                </el-form-item>
                <el-form-item label="策略类型 :" :label-width="labelWidth">
                    <el-select v-model="addConstantConfigForm.type">
                        <el-option
                            v-for="item in typeList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包名 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.appName"></el-input>
                </el-form-item>
                <el-form-item label="策略值 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.configValue"></el-input>
                </el-form-item>
                <el-form-item label="关联常量名 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.relName"></el-input>
                </el-form-item>
                <el-form-item label="用户开始时间 :" :label-width="labelWidth">
                    <el-date-picker
                        v-model="addConstantConfigForm.userStartDate"
                        type="datetime"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否可用:" :label-width="labelWidth">
                    <el-switch v-model="addConstantConfigForm.enable"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否"
                    >
                    </el-switch>
                </el-form-item>
                <el-form-item label="备注 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addConstantConfigForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="渠道筛选 :" :label-width="labelWidth">
                    <el-cascader v-model="addConstantConfigForm.subChannel" :options="channelList" :props="optionProps"
                                 clearable collapse-tags>
                    </el-cascader>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmConstantConfigForm">提 交</el-button>
                <el-button type="info" @click="dialogConstantConfigVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import utils from '@/utils'
import settingMix from '@/utils/mix/common-setting'
import {channelList, deleteAbTestConfig, saveAbTestConfig, searchAbtestConfig} from '@/http/api'

export default {
    name: "AbTestConfig",
    mixins: [settingMix],
    data() {
        return {
            dialogConstantConfigVisible: false,
            dialogConstantConfigTitle: '',
            labelWidth: '110px',
            list: [],
            channelList: [],
            optionProps: {
                emitPath: false,
                multiple: true,
                value: 'subChannel',
                label: 'name',
                children: 'children',
            },
            needGetApp: true,
            appList: [],
            typeList: [{name: "常量", id: 0}, {name: "其他", id: 1}],
            addConstantConfigForm: {
                id: null,
                name: null,
                type: null,
                appName: null,
                configValue: null,
                relName: null,
                userStartDate: null,
                enable: null,
                remark: '',
                subChannel: [],
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {
                appName: ""
            },
        }
    },
    methods: {
        typeFormatter: function (row, column, cellValue) {
            var temp = "其他"
            this.typeList.forEach(item => {
                if (item.id === cellValue) {
                    temp = item.name;
                }
            })
            return temp
        },
        formatDate: function (row, column, cellValue) {
            return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
        },
        formatSimpleDate: function (row, column, cellValue) {
            return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.getList();
        },
        getList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchAbtestConfig(this.queryData).then(resp => {
                this.list = resp.data.info.list;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        removeConstantConfig(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteAbTestConfig(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.getList();
                    }
                });
            }).catch(() => {
            })
        },
        showAddConstantConfigFormDialog(_title, _data) {
            this.dialogConstantConfigVisible = true;
            this.dialogConstantConfigTitle = _title;
            this.addConstantConfigForm = {
                id: null,
                name: '',
                type: null,
                appName: '',
                configValue: '',
                relName: '',
                userStartDate: null,
                enable: null,
                remark: '',
                subChannel: []
            };
            if (_data) {
                this.addConstantConfigForm = {
                    id: _data.id,
                    name: _data.name,
                    type: _data.type,
                    appName: _data.appName,
                    configValue: _data.configValue,
                    relName: _data.relName,
                    userStartDate: _data.userStartDate,
                    enable: _data.enable,
                    remark: _data.remark,
                    subChannel: _data.subChannelIds
                }
            }
        },
        confirmConstantConfigForm() {
            let _message = '';
            if (this.addConstantConfigForm.subChannel.length < 1) {
                _message = '请选择相关渠道'
            } else if (this.addConstantConfigForm.remark === '') {
                _message = '请填写备注，以防忘记配置内容'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            saveAbTestConfig(this.addConstantConfigForm).then(resp => {
                if (resp.data.status === 0) {
                    this.getList();
                    this.dialogConstantConfigVisible = false;
                }
            });
        }

    },
    created() {
        this.getList();
        let _this = this;
        channelList().then(resp => {
            this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
                if (channel.children) {
                    channel.children = channel.children.filter(sub => sub.state === 1)
                }
                return channel;
            }).filter(channel => channel.children && channel.children.length);
            this.channelList.forEach(function (channel) {
                _this.$set(channel, 'subChannel', channel.id);
            });
        });
    }
}
</script>

<style scoped>

</style>
